import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var XSVG = function XSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M24.052 3.345h4.293l-9.38 10.721L30 28.655h-8.64l-6.768-8.848-7.743 8.848H2.553l10.033-11.467L2 3.345h8.86l6.117 8.088 7.075-8.088Zm-1.507 22.74h2.379L9.567 5.78H7.014l15.53 20.305Z"
  }));
};
XSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(XSVG);